(function ($) {
  $(function () {
    $('.js-hero-banner-overlay-cta').click(function (e) {
      e.preventDefault();
      var perfectLipCarousel = $('.js-find-your-finish-carousel');

      if (perfectLipCarousel.length > 0) {
        var $stickyHeader = $('.js-site-header-sticky');
        var $htmlBody = $('html, body');
        var carousel_offset = perfectLipCarousel.offset().top;

        // Since sticky header height varies while scrolling, two .animate() used here
        $htmlBody.animate(
          {
            scrollTop: carousel_offset - $stickyHeader.height()
          },
          {
            complete: function () {
              $htmlBody.animate({
                scrollTop: carousel_offset - $stickyHeader.height()
              });
            },
            duration: 800
          }
        );
      }
    });
  });
})(jQuery);
